var map = {
	"./betting-history.svg": 980,
	"./commision-illustrate.svg": 981,
	"./commision-report.svg": 982,
	"./commission-plan.svg": 983,
	"./contact-us.svg": 984,
	"./contact.svg": 985,
	"./dashboard.svg": 986,
	"./delegate-deposit.svg": 987,
	"./deposit.svg": 988,
	"./financial-report.svg": 989,
	"./management.svg": 990,
	"./message-center.svg": 991,
	"./products.svg": 992,
	"./promote-link.svg": 993,
	"./region-language.svg": 994,
	"./terms-conditions.svg": 995,
	"./transaction-report.svg": 996,
	"./wallet.svg": 997,
	"./withdrawal.svg": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 492;